import clsx from 'clsx';
import styles from 'components/UI/V3/Timeline/Item/Meta/TimelineItemMeta.module.scss';
import React from 'react';

export interface TimelineItemMetaProps {
    title: string;
    description?: string;
    children?: React.ReactNode;
    className?: string;
}

export const TimelineItemMeta: React.FC<TimelineItemMetaProps> = ({ title, description, children, className }) => {
    return (
        <div className={clsx(styles.root, className)}>
            <h6 className={styles.title}>{title}</h6>

            {description && <p className={styles.description}>{description}</p>}

            {children}
        </div>
    );
};
